import { createRoot } from 'react-dom/client';
import '../css/admin_css.scss';
import { setDateTimeLocalization } from '@racemap/utilities/functions/datetime';
import { StrictMode } from 'react';
import { App } from './App';

setDateTimeLocalization();

const container = document.getElementById('root');
if (container == null) throw new Error('Could not find root element');

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
